<mx-object-form (customize)='onCustomize($event)'></mx-object-form>